<template>
  <div class="tab-module" v-if="props.headerData.subjectVoList && props.headerData.subjectVoList.length > 0">
    <div class="title-time" v-show="lineTrue" :style="{top: titleTop + 'px'}"></div>
    <Tabs
      :active="active"
      @scroll="handleScroll"
      :sticky="props.headerData.subjectVoList.length > 1"
      swipeable
      :ellipsis="false"
      @click-tab="handleTab"
      @change="handleChange"
      :offset-top="immersiveTitle ? barHeihgt : 0"
      clstag="8YQ5|108807"
      :data-qidian-ext="
        JSON.stringify({
          page_source: 2710513,
          page_name: props.headerData.sceneCollName,
          tagid: props.headerData.subjectVoList[active].topicAliasName,
          sourceName: props.headerData.subjectVoList[active].topicKey,
          sourceId: props.headerData.subjectVoList[active].id
        })
      "
    >
      <Tab
        v-for="(item, index) in props.headerData.subjectVoList.slice(0, 50)"
        :key="index"
        :title="item.topicAliasName"
      >
        <Feed
          v-if="active == index"
          :subjectVoList="props.headerData.subjectVoList"
          :tabData="tabData"
          :detailType="item.detailType"
          :headerData="props.headerData"
          :active="active"
        />
      </Tab>
    </Tabs>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref, toRefs, onBeforeUnmount, nextTick } from 'vue';
import * as tools from '@/utils/utils';
import { Tab, Tabs } from 'vant';
import TimeLine from './TimeLine'
import Feed from './Feed'

const props = defineProps({
  headerData: Object
});
const active = ref(0);
const immersiveTitle = ref(false)
const barHeihgt = ref(0)
const lineTrue = ref(false)
const titleTop = ref(null)
const tabData = reactive({
  subjectId: props.headerData.subjectVoList[0].id.toString(),
  tagId: props.headerData.subjectVoList[0].detailType == 3 ? 109 : 71
})
const onJrApp =(title, desc, img) => {
  if (tools.inJrApp()) {
    immersiveTitle.value = true;
    let configNavi = {
      version: 100,
      title: props.headerData.sceneCollName || document.title,
      moreItem: true,
      // backColor: ['#3e5cd7'],
      // textColor: 1,
      transparentConfig: {
        enable: true, //是否开启沉浸式
        title: props.headerData.sceneCollName,
        normalConfig: {
          //透明导航栏时的导航配置
          naviIcon: 1,
          showTitle: 0,
          bgColor: ''
        },
        scrollConfig: {
          //页面滚动时的导航配置
          naviIcon: 2,
          showTitle: 1,
          bgColor: '#FFFFFF'
        }
      },
      rightItemList: [
      {
        itemVersion: 0, // 固定字段 传0
        showItem: '', // 显示在导航栏的按钮图片
        jumpType: 2, // 按钮功能枚举 -(0-无反应 1-跳转页面 2-分享数据 3-说明弹窗 4-调整h5字体大小)
        jumpData: {
          imageUrl: 'https://storage.360buyimg.com/sharedata/logo300.png', // 分享缩略图 必须为https的地址 小于32k,必传
          linkSubtitle: props.headerData.summary || '京东金融综合互联网理财服务，基金理财，金融服务，敬请享受！', // 分享副标题 必传
          linkTitle: props.headerData.sceneCollName, // 分享主标题必传
          channels: [
            // 分享渠道 ：0-微信朋友圈，1-微信好友，2-新浪微博（已禁止），3-短信，4-QQ好友，5-QQ空间  6.1.20版本后不支持定制渠道
            '0',
            '1'
          ],
          channelList: [
            {
              // 建议使用的分享配置字段 5.1.0版本开始使用  支持分享链接(5.1.0) 、分享小程序（5.1.0）、分享纯文本（5.3.10）、分享口令弹窗（5.3.10）的分享字段
              shareType: 0, // 0:url(分享渠道均支持) 1:小程序(仅支持分享到微信好友) 2:纯文本(支持分享到微信好友，微信朋友圈) 3:口令弹窗(仅支持分享到微信好友) 必传
              id: '1', // 分享渠道  string类型 ：0-微信朋友圈，1-微信好友，2-新浪微博（已禁止），3-短信，4-QQ好友，5-QQ空间 必传
              /* 链接分享数据 */
              link: location.href // 分享出去的链接
            },
            {
              shareType: 0, // 0:url(分享渠道均支持) 1:小程序(仅支持分享到微信好友) 2:纯文本(支持分享到微信好友，微信朋友圈) 3:口令弹窗(仅支持分享到微信好友) 必传
              id: 1, // 分享渠道 ：0-微信朋友圈，1-微信好友，2-新浪微博（已禁止），3-短信，4-QQ好友，5-QQ空间 必传
              /* 链接分享数据 */
              link: location.href // 分享出去的链接
            }
          ]
        }
      }
    ],
    };
    window.JrBridge.setTopBar(configNavi);
    getBarHeight()

  }
}
const getBarHeight = () =>  {
  window.JrBridge.callNative(
    {
      type: '74'
    },
    data => {
      if (data && data.navBarTotalHeightDp) {
        barHeihgt.value = parseInt(data.navBarTotalHeightDp);
        titleTop.value = window.document.querySelector('.van-tabs__wrap').getBoundingClientRect().height + barHeihgt.value
      }
    }
  );
}
const handleScroll = (e) => {
  // console.log(e)
  if (e.isFixed) {
    window.document.getElementsByClassName('van-tabs__nav')[0].style.background = '#FFFFFF'
  } else {
    window.document.getElementsByClassName('van-tabs__nav')[0].style.background = 'rgba(244,245,247,1)'
  }
  if (props.headerData.subjectVoList[active.value].detailType == 3) {
    lineTrue.value = e.isFixed
  }
  
}

const handleTab = (item) => {
  lineTrue.value = false
  active.value = item.name
  tabData.subjectId = props.headerData.subjectVoList[item.name].id.toString()
  tabData.tagId = props.headerData.subjectVoList[item.name].detailType == 0 || props.headerData.subjectVoList[item.name].detailType == 2 ? 71 : 109
}

const handleChange = (item) => {
  lineTrue.value = false
  active.value = item
  tabData.subjectId = props.headerData.subjectVoList[item].id.toString()
  tabData.tagId = props.headerData.subjectVoList[item].detailType == 0 || props.headerData.subjectVoList[item].detailType == 2 ? 71 : 109
}

onMounted(() => {
  if (props.headerData.subjectVoList.length == 1) {
    window.document.getElementsByClassName('van-tabs__content')[0].style.marginTop = '10px'
    window.document.getElementsByClassName('van-tabs__wrap')[0].style.display = 'none'
  }
  onJrApp()
  titleTop.value = window.document.querySelector('.van-tabs__wrap').getBoundingClientRect().height
});

</script>

<style lang="scss" scoped>
.tab-module {
  position: relative;
  .top-white {
    height: 40px;
    background: #fff;
    position: absolute;
    left: 0;
    right: 0;
    top: -32px;
    z-index: 2;
    border-radius: 8px 8px 0 0;
  }
}
.title-time {
  position: fixed;
  left: 0;
  width: 750px;
  height: 90px;
  padding: 23px 0 23px 24px;
  background: rgba(255,255,255,1);
  box-shadow:  0 2px 14px 0 rgba(0,0,0,0.08);
  z-index: 333;
}
</style>
<style>
/* .van-tabs {
  padding-left: 24px;
} */
.van-tabs__wrap {
  height: 120px !important;
  padding: 0 24px;
}
.van-tabs__line {
  bottom: 54px;
}
.van-tabs__nav {
  background: rgba(244, 245, 247, 1);
}
.van-tabs__nav--line.van-tabs__nav--complete {
  padding-left: 0;
  padding-right: 0;
}
.van-tab {
  font-size: 36px;
  flex: none!important;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(153, 153, 153, 0.8);
  padding: 0 !important;
  margin-right: 48px;
}
.van-tab--active {
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
}
.van-tabs__line {
  width: 40px;
  height: 6px;
  background: rgba(239, 64, 52, 1);
  border-radius: 0;
}
.van-tabs__content {
  padding: 0 24px;
  border-radius: 8px;
}
.van-sticky--fixed {
  background: #ffffff !important;
}
</style>
